import { useQuery } from '@tanstack/react-query';
import { queryKeys, requestCCApi } from 'src/utils';

/* 
  Keep this hook to be automatically re-fetched, then we don't need to invalidate the query key in other requests.
*/
export const useGetHealthCheck = () =>
  useQuery({
    queryKey: queryKeys.healthCheck.all(),
    queryFn: fetchHealthCheck,
  });

export const fetchHealthCheck = async () => {
  const response = await requestCCApi({ url: '/health' });

  return response;
};
